import { InputProps } from '@chakra-ui/react';
import React, { useRef } from 'react';

import { CmButton } from '@/components/uiParts/Button/CmButton';

import { CmBox, CmFlex } from '..';

type Props = {
  src?: string;
  onClear?: () => void;
  onDelete?: () => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isDisabledDeleteButton: boolean;
} & InputProps;

export const CmUpload: React.FC<Props> = ({
  src,
  id,
  accept,
  onChange,
  onClear,
  onDelete,
  isDisabledDeleteButton,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <CmFlex className="cm-upload" alignItems="flex-start">
      <div>
        <label
          style={{
            display: 'block',
            width: 'fit-content',
            padding: '8px 18px',
            color: 'white',
            backgroundColor: '#394867',
            cursor: 'pointer',
            position: 'relative',
            borderRadius: '5px',
            fontWeight: 'bold',
          }}
        >
          <input
            type="file"
            name="file"
            // @ts-ignore TS2783
            id={'upload-input'}
            onReset={onClear}
            ref={inputRef}
            onChange={(e) => {
              onChange(e);
              /* NOTE e.target.value = '' を入れないと同じ画像を操作した時にイベントがイベントが発火しない */
              /* NOTE 参考: https://qiita.com/00__/items/73f59484f3ccaf42f481 */
              e.target.value = '';
            }}
            style={{
              visibility: 'hidden',
              position: 'absolute',
              top: 0,
              right: 0,
              left: 0,
              bottom: 0,
              width: '100%',
              fontWeight: 'bold',
            }}
            {...{ id, accept }}
          />
          画像を{src !== '' ? '変更' : '選択'}
        </label>
        {src !== '' && onClear !== undefined && (
          <CmBox
            style={{
              display: 'block',
              marginTop: '10px',
              padding: '6px 16px',
              backgroundColor: '#fff',
              border: '1px solid #A0AEC0',
              textAlign: 'center',
              color: '#405972',
              cursor: 'pointer',
              borderRadius: '5px',
              fontWeight: 'bold',
            }}
            onClick={onClear}
          >
            クリア
          </CmBox>
        )}
        {onDelete !== undefined && (
          // @ts-ignore TS2590
          <CmButton
            style={{
              display: 'block',
              marginTop: '10px',
              padding: '6px 16px',
              backgroundColor: '#E53E3E',
              border: '1px solid #E53E3E',
              textAlign: 'center',
              color: '#fff',
              cursor: 'pointer',
              borderRadius: '5px',
              fontWeight: 'bold',
            }}
            isDisabled={isDisabledDeleteButton}
            onClick={onDelete}
          >
            削除
          </CmButton>
        )}
      </div>
      {src !== '' && (
        <CmBox
          ml="10px"
          maxWidth="170px"
          maxHeight="130px"
          width="170px"
          height="130px"
          backgroundColor="#f5f5f5"
          position="relative"
        >
          <img
            style={{
              maxWidth: '170px',
              maxHeight: '130px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translateY(-50%) translateX(-50%)',
            }}
            {...{ src }}
            alt=""
          />
        </CmBox>
      )}
    </CmFlex>
  );
};
